import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppconfigService } from './appconfig.service';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor(private http: HttpClient, private config: AppconfigService) {
    this.apiUrl = this.config.apiBaseUrl;
  }

  // apiUrl: string = 'http://localhost:4200/api/MessageService.svc/ListaMarcacoes';
  //apiUrl: string = 'http://localhost:4200/api/MessageService.svc/UtentesToDeclaracaoRGPDListar';
   apiUrl: string = '';
   username: string = '';
   userpass: string = '';


  getUtentesBck(myData: Date) {
    //let dataStr: string = this.convertDate(myData);

    let dataStr: string = myData.toString();

    return this.http.post(this.apiUrl, {
      format: 'json',
      data: dataStr,
      efetivadas: 0,
      comFalta: 0
    })
  }

  getUtentes() {
    // let dataStr: string = this.convertDate(myData);
    // OrderRecievedDateTime is a proper date string
    // var tStart = new Date(myData);
    // // Get date in UTC (required for WCF) as morning
    // var start = new Date(Date.UTC(tStart.getFullYear(), tStart.getMonth(), tStart.getDate(), 0, 0, 0));
    // // Get the ticks
    // var startTicks = start.getTime();

    return this.http.post(this.apiUrl, {
      format: 'json'
    })

  }

  convertDate(date) {
    var yyyy = date.getFullYear().toString();
    var mm = (date.getMonth() + 1).toString();
    var dd = date.getDate().toString();

    var mmChars = mm.split('');
    var ddChars = dd.split('');

    return yyyy + '-' + (mmChars[1] ? mm : "0" + mmChars[0]) + '-' + (ddChars[1] ? dd : "0" + ddChars[0]);
  }

  getSample() {
    //return this.http.get('https://reqres.in/api/users')
    //return this.http.get('http://localhost:3000/utentes')
    //return this.http.get('http://localhost:56334/api/values')
    return this.http.get('http://localhost:3000/marcacoes');
  }

}
